//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as dat from 'dat.gui';
    import Code from './Code';
    import VueParticlesGenerator from 'vue-particles-generator';

    export default {
        name: 'Gui',
        components: {
            Code
        },
        data: () => ({
            gui: new dat.GUI({ autoPlace: false }),
            centerCoordinatesXController: null,
            centerCoordinatesYController: null,
            height: 400,
            width: 400,
            maxParticles: VueParticlesGenerator.props.maxParticles.default,
            nowParticles: VueParticlesGenerator.props.nowParticles.default,
            color: VueParticlesGenerator.props.color.default,
            particleType: VueParticlesGenerator.props.particleType.default,
            position: VueParticlesGenerator.props.position.default,
            centerCoordinatesX: VueParticlesGenerator.props.centerCoordinates.default()[0],
            centerCoordinatesY: VueParticlesGenerator.props.centerCoordinates.default()[1],
            velocity: VueParticlesGenerator.props.velocity.default,
            backgroundColor: '#1D1D1D',
            strokeSize: VueParticlesGenerator.props.strokeSize.default,
            strokeColor: VueParticlesGenerator.props.strokeColor.default,
            particleOpacity: VueParticlesGenerator.props.particleOpacity.default,
            particleSize: VueParticlesGenerator.props.particleSize.default,
            particleMaxSize: VueParticlesGenerator.props.particleMaxSize.default,
            isRandomColor: VueParticlesGenerator.props.isRandomColor.default,
            isRandomSize: VueParticlesGenerator.props.isRandomSize.default,
            isDeadParticle:  VueParticlesGenerator.props.isDeadParticle.default,
            isLoop:  VueParticlesGenerator.props.isLoop.default,
            shadowBlur:  VueParticlesGenerator.props.shadowBlur.default,
            shadowColor:  VueParticlesGenerator.props.shadowColor.default,
        }),
        created() {
            this.gui = new dat.GUI();
        },
        mounted() {
            this.initGui();
        },
        methods: {
            initGui() {
                this.gui.domElement.id = 'dat-gui';
                this.$refs.dgWrapper.appendChild(this.gui.domElement);
                this.gui.add(this, 'maxParticles', 500, 1000, 1);
                this.gui.add(this, 'nowParticles', 0, 500, 1);
                this.gui.addColor(this, 'color');
                this.gui.add(this, 'particleType', ['rect','circle','triangle','star','heart']);
                this.gui.add(this, 'velocity', 0, 100, 1);
                this.gui.addColor(this, 'backgroundColor');
                this.gui.add(this, 'strokeSize', 0, 10, 1);
                this.gui.addColor(this, 'strokeColor');
                this.gui.add(this, 'particleOpacity', 0, 1);
                this.gui.add(this, 'position', ['random','centerCanvas','centerCoordinates']);
                this.gui.add(this, 'particleSize', 0, 300, 1);
                this.gui.add(this, 'particleMaxSize', 0, 500, 1);
                this.gui.add(this, 'isRandomColor', [true, false]);
                this.gui.add(this, 'isRandomSize', [true, false]);
                this.gui.add(this, 'isDeadParticle', [true, false]);
                this.gui.add(this, 'isLoop', [true, false]);
                this.gui.add(this, 'shadowBlur', 0, 10, 1);
                this.gui.addColor(this, 'shadowColor');
            },
        },
        computed: {
            code() {
                return `<VueParticlesGenerator
    :width="${this.width}"
    :height="${this.height}"
    :maxParticles="${this.maxParticles}"
    :nowParticles="${this.nowParticles}"
    :color="${this.color}"
    :particleType="${this.particleType}"
    :position="${this.position}"
    :centerCoordinates="[${this.centerCoordinatesX}, ${this.centerCoordinatesY}]"
    :velocity="${this.velocity}"
    :backgroundColor="${this.backgroundColor}"
    :strokeSize="${this.strokeSize}"
    :strokeColor="${this.strokeColor}"
    :particleOpacity="${this.particleOpacity}"
    :particleSize="${this.particleSize}"
    :particleMaxSize="${this.particleMaxSize}"
    :isRandomColor="${this.isRandomColor}"
    :isRandomSize="${this.isRandomSize}"
    :isDeadParticle="${this.isDeadParticle}"
    :isLoop="${this.isLoop}"
    :shadowBlur="${this.shadowBlur}"
    :shadowColor="${this.shadowColor}"
/>`
            }
        },
        watch: {
            position(value, oldValue) {
                if (value === 'centerCoordinates') {
                    this.centerCoordinatesXController = this.gui.add(this, 'centerCoordinatesX', 0, this.width, 1);
                    this.centerCoordinatesYController = this.gui.add(this, 'centerCoordinatesY', 0, this.height, 1);
                } else if (oldValue === 'centerCoordinates') {
                    this.gui.remove(this.centerCoordinatesXController);
                    this.gui.remove(this.centerCoordinatesYController);
                }
            }
        },
    }
